import axios from "../plugins/parseAxios";
export class AreaInterestAPI {
  constructor(props) { }
  static createAreaInterest(payload) {
    return axios.post("functions/createAreaInterest", payload);
  }
}
